import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the shift request wizard asks for a picked child office's Personnel Service Agreement,
 * before posting (GOTU-7481). A refused post opens the same popup and fires nothing.
 * `funnelEntryId` is attached automatically — see `funnelRegistry`.
 * Event: dental_portal:shift_request:psa_popup_viewed
 */
export function fireShiftRequestPsaPopupViewed(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:psa_popup_viewed');
}
